export const ServiceEnums = {
    SIGGER: 0,
    MSA: 1
}